module.exports = __webpack_public_path__ + "img/154-swaziland.1238f45f.svg";